import { useState } from "react";

const ReservationForm = () => {
  const [location, setLocation] = useState("");

  const handleLocationChange = (e) => {
    const selected = e.target.value;
    setLocation(selected);
  };
  return (
    <form className="border-[1px] border-white p-4 rounded-md flex flex-col gap-3">
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="location" className="md:min-w-[120px]">
          Lokal
        </label>
        <select
          id="location"
          name="location"
          value={location}
          onChange={handleLocationChange}
          className="p-2 rounded-md text-black w-full"
        >
          <option value="">Wybierz lokal...</option>
          <option value="Toruń">Toruń</option>
          <option value="Bydgoszcz">Bydgoszcz</option>
          <option value="Gdańsk">Gdańsk</option>
        </select>
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="client" className="min-w-[120px]">
          Klient
        </label>
        <input
          id="client"
          type="text"
          placeholder="np. Jan Kowalski"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="mail" className="min-w-[120px]">
          E-mail
        </label>
        <input
          id="mail"
          type="text"
          placeholder="jan@kowalski.pl"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="phone" className="min-w-[120px]">
          Telefon
        </label>
        <input
          id="phone"
          type="text"
          placeholder="+48 123-456-789"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="date" className="min-w-[120px]">
          Data
        </label>
        <input
          id="date"
          type="date"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center">
        <label htmlFor="time" className="min-w-[120px]">
          Godzina
        </label>
        <input
          id="time"
          name="time"
          type="time"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="peopleNo" className="min-w-[120px]">
          Ilość osób
        </label>
        <input
          id="peopleNo"
          type="number"
          className="p-2 rounded-md text-black w-full"
          placeholder="np. 2"
        />
      </div>
      <div className="flex flex-col md:flex-row gap-2 md:items-center ">
        <label htmlFor="desc" className="min-w-[120px]">
          Uwagi
        </label>
        <textarea
          id="desc"
          name="desc"
          type="number"
          className="p-2 rounded-md text-black w-full"
        />
      </div>
      <div className="flex flex-row gap-2 md:items-center ">
        <input type="checkbox" id="confirmation" />
        <label htmlFor="confirmation">
          Wyrażam zgodę na przetwarzanie danych do procesu rezerwacji
        </label>
      </div>
      <button className="bg-red-600 py-3 rounded-md">Rezerwuj</button>
    </form>
  );
};

export default ReservationForm;
